import { Component } from '@angular/core';

@Component({
  selector: 'app-location-detail',
  templateUrl: './location-detail-ctl.component.html'
})
export class LocationDetailComponent {
  loc: any;
  events: any[];
  pager: any;
  members: any[];
  weatherWorking: boolean;
  error: string;

  constructor() {
    // Initialize properties
    this.loc = null;
    this.events = [];
    this.pager = null;
    this.members = [];
    this.weatherWorking = false;
    this.error = '';

    // Fetch location data, events, and members
    this.fetchLocationData();
    this.fetchEvents();
    this.fetchMembers();
  }

  fetchLocationData() {
    // Implement the logic to fetch location data using the appropriate service or API call
    // Assign the fetched data to this.loc
  }

  fetchEvents() {
    // Implement the logic to fetch events data using the appropriate service or API call
    // Assign the fetched data to this.events and this.pager
  }

  fetchMembers() {
    // Implement the logic to fetch members data using the appropriate service or API call
    // Assign the fetched data to this.members
  }

  pageChanged() {
    // Implement the logic to handle page change event
    // Update the URL with the new page using router navigation
  }

  sendWeatherAlert(severity: string) {
    this.weatherWorking = true;
    let title = '';
    let summary = '';
    let areaDesc = '';

    switch (severity) {
      case 'Minor':
        title = 'Dense Fog Advisory';
        summary = '...DENSE FOG ADVISORY IN EFFECT UNTIL 9 AM CDT SATURDAY... .CONDITIONS HAVE BECOME FAVORABLE FOR FOG FORMATION ACROSS THE MIDSOUTH. AT THIS HOUR...VISIBILITIES IS DIMINISHING WITH VISIBILITY OF LESS THAN A QUARTER OF A MILE POSSIBLE OVER THE NEXT SEVERAL HOURS. DENSE FOG WILL LIKELY REMAIN AN ISSUE THROUGH AT LEAST THE MID MORNING HOURS...BEFORE BURNING OFF BY MID MORNING.';
        areaDesc = 'Riverside County Mountains; San Bernardino County Mountains';
        break;
      case 'Moderate':
        title = 'Beach Hazards Statement';
        summary = '...BEACH HAZARDS STATEMENT IN EFFECT THROUGH LATE TONIGHT... ...COASTAL FLOOD ADVISORY REMAINS IN EFFECT FROM 9 AM SUNDAY TO 3 PM PDT MONDAY... THE NATIONAL WEATHER SERVICE IN SAN FRANCISCO HAS ISSUED A BEACH HAZARDS STATEMENT FOR LARGE SHORE BREAK...WHICH IS IN EFFECT THROUGH LATE TONIGHT.';
        areaDesc = 'San Francisco';
        break;
      case 'Severe':
        title = 'Flash Flood Watch';
        summary = '...FLASH FLOOD WATCH IN EFFECT FROM SATURDAY AFTERNOON THROUGH LATE SATURDAY NIGHT FOR THE LITTLE VALLEY AND EMERALD FIRE BURN SCARS... THE NATIONAL WEATHER SERVICE IN RENO HAS ISSUED A * FLASH FLOOD WATCH FOR THE LITTLE VALLEY AND EMERALD FIRE BURN SCARS.';
        areaDesc = 'Northern Washoe County';
        break;
      case 'Extreme':
        title = 'Tornado Warning';
        summary = 'The National Weather Service in Pleasant Hill has issued a * Tornado Warning for... Central Gentry County in northwestern Missouri... Southeastern Nodaway County in northwestern Missouri... * Until 915 PM CDT * At 847 PM CDT, a severe thunderstorm capable of producing a tornado';
        areaDesc = 'Central Gentry County; Southeastern Nodaway County';
        break;
    }

    // Implement the logic to send weather alert using the appropriate service or API call
    // Pass the necessary data to the API call
    // Handle success and error cases

    // Example API call:
    /*
    api.post('location/' + this.loc.id + '/weather', {
      "title": title,
      "summary": summary,
      "severity": severity,
      "area_desc": areaDesc,
    }).then(() => {
      // Handle success
    }).catch((error) => {
      // Handle error
      this.error = errorFromResponse(error);
    }).finally(() => {
      this.weatherWorking = false;
    });
    */
  }
}
